import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import i18n from "@i18n";
import { ProjectKanbanBlockRepository } from "@project/data/repositories/project-kanban-block.repository";
import { inject, injectable } from "inversify";

@injectable()
export class DeleteProjectKanbanBlockUseCase {
    constructor(
        @inject(ProjectKanbanBlockRepository)
        private readonly repository: ProjectKanbanBlockRepository,
    ) {}

    async execute(id: number): Promise<boolean> {
        const result = await this.repository.delete(id);

        if (result.isLeft()) {
            ToastManagerStore.error(
                i18n.t("component:toastManager.defaultError"),
            );
            return false;
        }

        return true;
    }
}
